(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["travel-fit-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCarousel = (carousel) => {
      if (!carousel || carousel.dataset.travelFitReady === 'true') return;

      const viewport = carousel.querySelector('[data-travel-fit-viewport]');
      const track = carousel.querySelector('[data-travel-fit-track]');
      const slides = Array.from(carousel.querySelectorAll('[data-travel-fit-slide]'));
      const prev = carousel.querySelector('[data-travel-fit-prev]');
      const next = carousel.querySelector('[data-travel-fit-next]');
      const progress = carousel.querySelector('[data-travel-fit-progress]');
      const progressThumb = carousel.querySelector('[data-travel-fit-progress-thumb]');
      const mobileQuery = window.matchMedia('(max-width: 899px)');

      if (!viewport || !track || slides.length === 0) return;

      carousel.dataset.travelFitReady = 'true';

      let index = 0;
      let scrollTimer = null;

      const getMaxScroll = () => Math.max(0, viewport.scrollWidth - viewport.clientWidth);

      const getSlideTarget = (slide) => {
        const viewportRect = viewport.getBoundingClientRect();
        const slideRect = slide.getBoundingClientRect();
        const rawLeft = viewport.scrollLeft + (slideRect.left - viewportRect.left);

        return Math.max(0, Math.min(getMaxScroll(), rawLeft));
      };

      const setActive = (newIndex) => {
        index = Math.max(0, Math.min(slides.length - 1, newIndex));

        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.classList.toggle('is-active', active);

          if (active) slide.setAttribute('aria-current', 'true');
          else slide.removeAttribute('aria-current');
        });
      };

      const updateProgress = () => {
        if (!progress || !progressThumb || !mobileQuery.matches || slides.length <= 1) {
          if (progress) progress.hidden = true;
          return;
        }

        const maxScroll = getMaxScroll();
        const current = Math.min(maxScroll, Math.max(0, viewport.scrollLeft));
        const ratio = maxScroll > 0 ? current / maxScroll : 0;

        const slideWidth = slides[0]?.offsetWidth || viewport.clientWidth || 1;
        const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
        const visibleSlides = Math.max(1, viewport.clientWidth / Math.max(1, slideWidth + gap));
        const visibleRatio = Math.min(1, visibleSlides / slides.length);
        const thumbWidth = Math.max(18, visibleRatio * 100);
        const left = ratio * (100 - thumbWidth);

        progress.hidden = false;
        progressThumb.style.width = thumbWidth.toFixed(2) + '%';
        progressThumb.style.left = left.toFixed(2) + '%';
      };

      const findClosestIndex = () => {
        const currentLeft = viewport.scrollLeft;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        slides.forEach((slide, slideIndex) => {
          const distance = Math.abs(getSlideTarget(slide) - currentLeft);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = slideIndex;
          }
        });

        return closestIndex;
      };

      const goTo = (newIndex, behavior = 'smooth') => {
        const normalizedIndex = (newIndex + slides.length) % slides.length;
        const target = slides[normalizedIndex];

        setActive(normalizedIndex);

        viewport.scrollTo({
          left: getSlideTarget(target),
          behavior
        });

        window.setTimeout(updateProgress, behavior === 'smooth' ? 320 : 0);
      };

      const refresh = () => {
        if (!mobileQuery.matches) {
          viewport.scrollTo({
            left: getSlideTarget(slides[index]),
            behavior: 'auto'
          });
        }

        window.requestAnimationFrame(updateProgress);
      };

      setActive(0);
      refresh();

      if (slides.length > 1) {
        if (prev) {
          prev.addEventListener('click', (event) => {
            if (mobileQuery.matches) return;
            event.preventDefault();
            event.stopPropagation();
            goTo(index - 1);
          });
        }

        if (next) {
          next.addEventListener('click', (event) => {
            if (mobileQuery.matches) return;
            event.preventDefault();
            event.stopPropagation();
            goTo(index + 1);
          });
        }

        viewport.addEventListener('scroll', () => {
          if (!mobileQuery.matches) return;

          updateProgress();

          window.clearTimeout(scrollTimer);
          scrollTimer = window.setTimeout(() => {
            setActive(findClosestIndex());
          }, 120);
        }, { passive: true });
      }

      if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', refresh);
      }

      window.addEventListener('resize', refresh, { passive: true });

      carousel._travelFitShow = goTo;
      carousel._travelFitUpdateProgress = updateProgress;
      carousel._travelFitRefresh = refresh;
    };

    const initWithin = (root) => {
      root.querySelectorAll('[data-travel-fit-carousel]').forEach(initCarousel);
    };

    initWithin(document);

    document.addEventListener('shopify:section:load', (event) => {
      initWithin(event.target);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest('[data-travel-fit-slide]');
      if (!slide) return;

      const carousel = slide.closest('[data-travel-fit-carousel]');
      if (!carousel || !carousel._travelFitShow) return;

      if (carousel._travelFitRefresh) carousel._travelFitRefresh();
      carousel._travelFitShow(Number(slide.dataset.index) || 0, 'auto');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
